/** A completed submission, distinct from acceptance, payment, or an outbound click. */
export const LEAD_EVENT = "generate_lead" as const;

type LeadIdentity = {
  /** Stable enrollment identity, never the Everflow transaction ID. */
  enrollmentItemId: string;
  programId: string;
  providerId: string;
};

export type LeadConversion = LeadIdentity &
  (
    | { leadSource: "form_funnel_hosted"; funnelId: string }
    | { leadSource: "program_flow_hosted"; funnelId?: string }
    | { leadSource: "external_school"; funnelId?: string }
  );

export type LeadSource = LeadConversion["leadSource"];

/** Explicit allowlist: no contact information, answers, or inferred revenue. */
export const buildLeadConversionParams = ({
  enrollmentItemId,
  leadSource,
  programId,
  providerId,
  funnelId,
}: LeadConversion) => ({
  transaction_id: enrollmentItemId,
  lead_source: leadSource,
  program_id: programId,
  provider_id: providerId,
  ...(funnelId && { form_funnel_id: funnelId }),
});
